import { Injectable } from '@angular/core';

import { PrettyUrlsConfig, RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { IntlService } from '@frontend/vanilla/core';

import { GreyhoundRacingApiService } from '../../../../horse-racing-shared/services/greyhound-racing-api.service';
import { RacingAllResolver } from '../../horses-meeting/horses-meeting-all.resolver';

@Injectable()
export class GreyhoundsMeetingAllResolver extends RacingAllResolver {
    constructor(horseRacingApi: GreyhoundRacingApiService, urlConfig: PrettyUrlsConfig, intlService: IntlService, racingConfig: RacingConfig) {
        super(horseRacingApi, urlConfig, intlService, racingConfig);
    }
}
